// Auto-generated Matplotlib Components Map

import Matplotlib from "./matplotlib_components/matplotlib_components/Matplotlib.jsx";
import Matplotlib_Bars from "./matplotlib_components/matplotlib_components/Matplotlib_Bars.jsx";
import Matplotlib_GetStarted from "./matplotlib_components/matplotlib_components/Matplotlib_GetStarted.jsx";
import Matplotlib_Grid from "./matplotlib_components/matplotlib_components/Matplotlib_Grid.jsx";
import Matplotlib_Histograms from "./matplotlib_components/matplotlib_components/Matplotlib_Histograms.jsx";
import Matplotlib_Intro from "./matplotlib_components/matplotlib_components/Matplotlib_Intro.jsx";
import Matplotlib_Labels from "./matplotlib_components/matplotlib_components/Matplotlib_Labels.jsx";
import Matplotlib_Line from "./matplotlib_components/matplotlib_components/Matplotlib_Line.jsx";
import Matplotlib_Markers from "./matplotlib_components/matplotlib_components/Matplotlib_Markers.jsx";
import Matplotlib_PieCharts from "./matplotlib_components/matplotlib_components/Matplotlib_PieCharts.jsx";
import Matplotlib_Plotting from "./matplotlib_components/matplotlib_components/Matplotlib_Plotting.jsx";
import Matplotlib_Pyplot from "./matplotlib_components/matplotlib_components/Matplotlib_Pyplot.jsx";
import Matplotlib_Scatter from "./matplotlib_components/matplotlib_components/Matplotlib_Scatter.jsx";
import Matplotlib_Subplot from "./matplotlib_components/matplotlib_components/Matplotlib_Subplot.jsx";

const matplotlibComponentsMap = {
  "<Matplotlib />": Matplotlib,
  "<Matplotlib_Bars />": Matplotlib_Bars,
  "<Matplotlib_GetStarted />": Matplotlib_GetStarted,
  "<Matplotlib_Grid />": Matplotlib_Grid,
  "<Matplotlib_Histograms />": Matplotlib_Histograms,
  "<Matplotlib_Intro />": Matplotlib_Intro,
  "<Matplotlib_Labels />": Matplotlib_Labels,
  "<Matplotlib_Line />": Matplotlib_Line,
  "<Matplotlib_Markers />": Matplotlib_Markers,
  "<Matplotlib_PieCharts />": Matplotlib_PieCharts,
  "<Matplotlib_Plotting />": Matplotlib_Plotting,
  "<Matplotlib_Pyplot />": Matplotlib_Pyplot,
  "<Matplotlib_Scatter />": Matplotlib_Scatter,
  "<Matplotlib_Subplot />": Matplotlib_Subplot,
};

export default matplotlibComponentsMap;
